export default [
  {
    path: 'consultas/vendas-creditos',
    name: 'vendas-creditos',
    component: () => import('./index'),
    meta: {
      visible: true,
      title: 'Vendas de Créditos',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Consultas', link: 'consultas' },
        { name: 'Histórico de Vendas' }
      ]
    }
  }
]